(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/play-buttons.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/play-buttons.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
const {
  rowPrice
} = svs.numbergames.rules.EUROJACKPOT;
const PlayButtons = () => {
  const handleClick = numberOfRows => {
    svs.utils.url.navigate("".concat(svs.core.urlMapping.get('eurojackpotPlay'), "/spela?rader=").concat(numberOfRows, "&dag=n"));
  };
  const [firstDraw] = svs.numbergames.draws.drawsUtils.sortProductsByDrawTime(productMapping.CONSTANTS.EUROJACKPOT);
  const date = new Date(firstDraw.regCloseTime);
  let day;
  switch (true) {
    case dateFns.isToday(date):
      day = 'idag';
      break;
    case dateFns.isTomorrow(date):
      day = 'imorgon';
      break;
    default:
      day = productMapping.getDay(firstDraw === null || firstDraw === void 0 ? void 0 : firstDraw.productItsId).toLowerCase();
  }
  const drawTitle = "Dragning ".concat(day);
  return React.createElement("div", {
    className: "eurojackpot-play-buttons-wrapper"
  }, React.createElement("div", {
    className: "eurojackpot-play-buttons"
  }, React.createElement("h2", {
    className: "eurojackpot-play-buttons-title"
  }, drawTitle), React.createElement("div", {
    className: "eurojackpot-play-buttons-grid"
  }, React.createElement("button", {
    className: "eurojackpot-play-button",
    onClick: () => handleClick(2),
    type: "button"
  }, React.createElement("p", {
    className: "button-title"
  }, "2 rader"), React.createElement("h3", {
    className: "button-price"
  }, 2 * rowPrice, ' ', "kr")), React.createElement("button", {
    className: "eurojackpot-play-button",
    onClick: () => handleClick(4),
    type: "button"
  }, React.createElement("p", {
    className: "button-title"
  }, "4 rader"), React.createElement("h3", {
    className: "button-price"
  }, 4 * rowPrice, ' ', "kr")), React.createElement("button", {
    className: "eurojackpot-play-button",
    onClick: () => handleClick(6),
    type: "button"
  }, React.createElement("p", {
    className: "button-title"
  }, "6 rader"), React.createElement("h3", {
    className: "button-price"
  }, 6 * rowPrice, ' ', "kr")), React.createElement("button", {
    className: "eurojackpot-play-button",
    onClick: () => handleClick(20),
    type: "button"
  }, React.createElement("p", {
    className: "button-title"
  }, "20 rader"), React.createElement("h3", {
    className: "button-price"
  }, 20 * rowPrice, ' ', "kr")))));
};
setGlobal('svs.eurojackpot.react.components', {
  PlayButtons
});

 })(window);